import React, { useEffect, useState } from "react";
import api from "../../api";

export default function MusicControlPage() {
  const [outlets, setOutlets] = useState([]);
  const [status, setStatus] = useState({}); // online status
  const [nowPlaying, setNowPlaying] = useState({}); // track info
  const [sortOrder, setSortOrder] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(15);
  const [statusFilter, setStatusFilter] = useState("all");
  // all | online | offline

  // WebSocket for real-time updates
  useEffect(() => {
    const ws = new WebSocket("wss://capimusic.synoweberp.in");
    // const ws = new WebSocket("ws://192.168.1.63:5000");

    ws.onopen = () => {
      console.log("Admin WS connected");
    };

    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);

      // Online / Offline updates
      if (data.type === "status") {
        setStatus((prev) => ({
          ...prev,
          [data.outletId]: data.online,
        }));
      }

      // Now playing updates
      if (data.type === "playing") {
        setNowPlaying((prev) => ({
          ...prev,
          [data.outletId]: data,
        }));
      }
    };

    ws.onerror = (e) => {
      console.error("Admin WS error", e);
    };

    ws.onclose = () => {
      console.log("Admin WS disconnected");
    };

    return () => ws.close();
  }, []);

  // Load outlets initially
  useEffect(() => {
    loadOutlets();
  }, []);

  const loadOutlets = async () => {
    const res = await api.get("/api/outlets");
    setOutlets(res.data);
  };

  const sendCommand = async (outletId, command) => {
    try {
      await api.post("/api/remote/control", { outletId, command });
    } catch {
      alert("Outlet offline");
    }
  };

  const formatTime = (sec) => {
    if (!sec) return "0:00";
    const m = Math.floor(sec / 60);
    const s = Math.floor(sec % 60)
      .toString()
      .padStart(2, "0");
    return `${m}:${s}`;
  };
  const totalOutlets = outlets.length;

  const onlineOutlets = Object.values(status).filter(Boolean).length;

  const sortedOutlets = [...outlets].sort((a, b) => {
    if (sortOrder === "asc") {
      return new Date(a.createdAt) - new Date(b.createdAt);
    } else {
      return new Date(b.createdAt) - new Date(a.createdAt);
    }
  });

  const filteredOutlets = sortedOutlets.filter((o) => {
    if (statusFilter === "online") return status[o._id];
    if (statusFilter === "offline") return !status[o._id];
    return true;
  });

  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;

  const currentOutlets = filteredOutlets.slice(indexOfFirst, indexOfLast);

  const totalPages = Math.ceil(filteredOutlets.length / itemsPerPage);

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6 text-center">
        Outlet Music Status
      </h1>

      <div className="flex gap-3 mb-4">
        <button
          onClick={() => setStatusFilter("all")}
          className={`px-3 py-1 rounded ${
            statusFilter === "all" ? "bg-blue-500 text-white" : "bg-gray-200"
          }`}
        >
          All
        </button>

        <button
          onClick={() => setStatusFilter("online")}
          className={`px-3 py-1 rounded ${
            statusFilter === "online"
              ? "bg-green-500 text-white"
              : "bg-gray-200"
          }`}
        >
          Online
        </button>

        <button
          onClick={() => setStatusFilter("offline")}
          className={`px-3 py-1 rounded ${
            statusFilter === "offline" ? "bg-red-500 text-white" : "bg-gray-200"
          }`}
        >
          Offline
        </button>
      </div>
      <div className="flex gap-6 mb-4 text-sm font-semibold">
        <div className="text-blue-600">Total Outlets: {totalOutlets}</div>
        <div className="text-green-600">Online: {onlineOutlets}</div>
        <div className="text-red-500">
          Offline: {totalOutlets - onlineOutlets}
        </div>
      </div>

      <table className="w-full bg-white shadow rounded">
        <thead className="bg-gray-100">
          <tr>
            <th className="p-3 text-left">S.No</th>

            <th
              className="p-3 text-left cursor-pointer"
              onClick={() => setSortOrder(sortOrder === "asc" ? "desc" : "asc")}
            >
              Outlet {sortOrder === "asc" ? "⬆️" : "⬇️"}
            </th>

            <th className="p-3 text-left">Status</th>
          </tr>
        </thead>

        <tbody>
          {currentOutlets.map((o, index) => {
            const now = nowPlaying[o._id];

            return (
              <tr key={o._id} className="border-b">
                <td className="p-3">{indexOfFirst + index + 1}</td>

                <td className="p-3 font-semibold">{o.name}</td>

                {/* ONLINE STATUS */}
                <td className="p-3">
                  {status[o._id] ? (
                    <span className="text-green-600 font-bold">🟢 Online</span>
                  ) : (
                    <span className="text-red-500 font-bold">🔴 Offline</span>
                  )}
                </td>

                {/* PLAYLIST NAME */}
                {/* <td className="p-3">
                  {now?.playlistName || "—"}
                </td> */}

                {/* SONG NAME */}
                {/* <td className="p-3">
                  {now?.trackTitle || "—"}
                </td> */}

                {/* PROGRESS */}
                {/* <td className="p-3">
                  {now
                    ? `${formatTime(now.position)} / ${formatTime(now.duration)}`
                    : "—"}
                </td> */}

                {/* CONTROL BUTTONS */}
                {/* <td className="p-3">
                  <div className="flex gap-2">
                    <button
                      onClick={() => sendCommand(o._id, "prev")}
                      className="bg-blue-500 text-white px-3 py-1 rounded"
                    >
                      ⏮
                    </button>

                    <button
                      onClick={() => sendCommand(o._id, "play")}
                      className="bg-green-500 text-white px-3 py-1 rounded"
                    >
                      ▶
                    </button>

                    <button
                      onClick={() => sendCommand(o._id, "pause")}
                      className="bg-yellow-500 text-white px-3 py-1 rounded"
                    >
                      ⏸
                    </button>

                    <button
                      onClick={() => sendCommand(o._id, "next")}
                      className="bg-purple-500 text-white px-3 py-1 rounded"
                    >
                      ⏭
                    </button>
                  </div>
                </td> */}
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="flex justify-center gap-2 mt-6">
        <button
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((p) => p - 1)}
          className="px-3 py-1 bg-gray-200 rounded"
        >
          Prev
        </button>

        <span className="px-3 py-1">
          Page {currentPage} of {totalPages}
        </span>

        <button
          disabled={currentPage === totalPages}
          onClick={() => setCurrentPage((p) => p + 1)}
          className="px-3 py-1 bg-gray-200 rounded"
        >
          Next
        </button>
      </div>
      <div className="text-center text-gray-500 mt-6 text-sm">
        Live updates require devices to be online.
      </div>
    </div>
  );
}
